import { defineStore } from 'pinia'

const MAX_VISIBLE = 3
let nextId = 1

const DURATION_BY_TYPE = {
  error: 7000,
  warn: 5000,
  info: 5000,
}

export const useToastStore = defineStore('toast', {
  state: () => ({
    items: [], // { id, message, type, duration, _timeout }
  }),

  actions: {
    show({ message, type = 'info', duration = null }) {
      const finalDuration = duration ?? DURATION_BY_TYPE[type] ?? 5000

      // Mismo mensaje ya visible: reinicia su timer en vez de apilar duplicados
      const existing = this.items.find((i) => i.message === message && i.type === type)
      if (existing) {
        if (existing._timeout) clearTimeout(existing._timeout)
        if (finalDuration > 0) {
          existing._timeout = setTimeout(() => this.dismiss(existing.id), finalDuration)
        }
        return existing.id
      }

      const id = nextId++
      const item = { id, message, type, duration: finalDuration, _timeout: null }

      this.items.push(item)

      while (this.items.length > MAX_VISIBLE) {
        this.dismiss(this.items[0].id)
      }

      if (finalDuration > 0) {
        item._timeout = setTimeout(() => this.dismiss(id), finalDuration)
      }
      return id
    },

    error(message, opts = {}) { return this.show({ ...opts, message, type: 'error' }) },
    warn(message, opts = {})  { return this.show({ ...opts, message, type: 'warn' }) },
    info(message, opts = {})  { return this.show({ ...opts, message, type: 'info' }) },

    dismiss(id) {
      const idx = this.items.findIndex((i) => i.id === id)
      if (idx < 0) return
      const item = this.items[idx]
      if (item._timeout) clearTimeout(item._timeout)
      this.items.splice(idx, 1)
    },

    clear() {
      this.items.forEach((i) => i._timeout && clearTimeout(i._timeout))
      this.items = []
    },
  },
})
